module.exports = __webpack_public_path__ + "assets/img/32_577_big.58f50766.jpg";